module.exports = __webpack_public_path__ + "static/media/lohi-light.d0d281f3.svg";